<template>
  <div id="app">
    <router-view/>
    <rotate-it />
  </div>
</template>

<script>
import RotateIt from './components/Rotate';

export default {
  name: 'App',
  components: {
    'rotate-it': RotateIt
  }
}
</script>

<style>
/* 重置样式 */
* {
  -webkit-tap-highlight-color: transparent;
  outline: 0;
  /* pointer-events: none; */
  }

body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, dl, dt, dd, ul, ol, li, pre, form, fieldset, legend, button, input, textarea, th, td {
  margin: 0;
  padding: 0;
  vertical-align: baseline; }

img {
  border: 0 none;
  vertical-align: top; }

i, em {
  font-style: normal; }

ol, ul {
  list-style: none; }

input, select, button, h1, h2, h3, h4, h5, h6 {
  font-size: 100%;
  font-family: inherit; }

table {
  border-collapse: collapse;
  border-spacing: 0; }

a, a:visited {
  text-decoration: none;
  color: #333; }

body {
  margin: 0 auto;
  background: #e8e8ed;
  font-size: 14px;
  font-family: -apple-system,Helvetica,sans-serif;
  line-height: 1.5;
  /* position: fixed; */
  color: #666;
  -webkit-text-size-adjust: 100% !important;
  -webkit-user-select: none;
  user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}

#app {
  width: 100%;
  height: 100%
}
</style>



// WEBPACK FOOTER //
// src/App.vue